import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ReviewMessageResponse } from 'lemunzo-api';
import { DialogData } from '../../models/notification-dialog-model';
import { SharedDialogShellConfig } from '../../models/shared-dialog-shell-config';
import { TranslateDatePipe } from '../../pipes/translate-date.pipe';
import { TableConfigService } from '../../services/table-config.service';
import { SharedDialogShellComponent } from '../shared-dialog-shell/shared-dialog-shell.component';

// TODO #CSD-1625: wire NotificationReaderComponent to a real ReviewMessage data source
@Component({
    selector: 'apcam-notification-confirmation',
    templateUrl: './notification-dialog.component.html',
    styleUrls: ['./notification-dialog.component.scss'],
    imports: [
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
        MatButtonModule,
        SharedDialogShellComponent,
        TranslatePipe,
        TranslateDatePipe,
    ],
})
export class NotificationDialogComponent implements AfterViewInit {
    protected get dialogShellConfig(): SharedDialogShellConfig<void> {
        return {
            title: this.translateService.instant(
                'shared.notificationDialog.notifications'
            ),
            cancelLabel: this.translateService.instant('shared.buttons.close'),
            cancelIcon: 'close',
            showConfirmButton: false,
            onCancel: () => this.dialogRef.close(),
        };
    }

    dataSource: MatTableDataSource<ReviewMessageResponse> =
        new MatTableDataSource();

    displayedColumns: string[] = ['id', 'createdAt', 'message'];

    flexGrowCols = {
        id: 0.1,
        createdAt: 0.3,
    };

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private readonly dialogRef: MatDialogRef<NotificationDialogComponent>,
        private readonly translateService: TranslateService
    ) {
        this.dataSource.data = data.notifications;
    }

    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    protected readonly TableConfigService = TableConfigService;
}
